const styles = (theme) => ({
  anchorOriginTopRight: {
    top: theme.hv.spacing.xs,
    right: theme.hv.spacing.xs,
  },
  anchorOriginTopLeft: {
    top: theme.hv.spacing.xs,
    left: theme.hv.spacing.xs,
  },
  anchorOriginTopCenter: {
    top: theme.hv.spacing.xs,
  },
  anchorOriginBottomCenter: {
    bottom: theme.hv.spacing.xs,
  },
  anchorOriginBottomLeft: {
    bottom: theme.hv.spacing.xs,
    left: theme.hv.spacing.xs,
  },
  anchorOriginBottomRight: {
    bottom: theme.hv.spacing.xs,
    right: theme.hv.spacing.xs,
  },
});

export default styles;
